"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const comfirm_form_1 = __importDefault(require("./comfirm.form"));
const Field_1 = __importDefault(require("../../_classes/field/Field"));
const AriFormUtils = __importStar(require("../../../utils/utils"));
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
/**
 * Here we will derive from the base component which all Ari.Form form components derive from.
 * @param component
 * @param options
 * @param data
 * @class
 */
class ComfirmComponent extends Field_1.default {
    constructor(component, options, data) {
        super(component, options, data);
        this.checks = [];
        this.textContent = this.component.textContent || '';
    }
    static schema(...extend) {
        return Field_1.default.schema({
            type: 'comfirm',
            label: 'Comfirm',
            displayInfo: false,
            textContent: '',
            align: 'justify-content-start',
            action: 'event',
            templatesComfirm: ComfirmComponent.defaultRowTemplate,
            formattedDataTemplate: ComfirmComponent.defaultFormattedTemplate
        }, ...extend);
    }
    get defaultSchema() {
        return ComfirmComponent.schema();
    }
    get emptyValue() {
        return this.getValue();
    }
    static get defaultRowTemplate() {
        return `
   <div class="accordion <%= comfirmType === 'OpenFist' ? 'accordion-flush' : '' %>" id="<%= componentKey %>-accordionExample">
  <% for (var i = 0; i < value.length; i++) { %>
    <div class="accordion-item">
      <h2 class="accordion-header" id="heading-<%= i %>">
        <button class="accordion-button <%= i === 0 ? '' : 'collapsed' %>" 
                type="button" 
                data-bs-toggle="collapse"
                data-bs-target="#collapse-<%= i %>"
                aria-expanded="<%= i === 0 ? 'true' : 'false' %>"
                aria-controls="collapse-<%= i %>">
          <%= utils.getLangText(value[i].title) %>
        </button>
      </h2>

      <div id="collapse-<%= i %>" 
           class="accordion-collapse collapse <%= i === 0 && comfirmType !== 'closeAll' ? 'show' : '' %>" 
           aria-labelledby="heading-<%= i %>"
           <%= comfirmType === 'alwaysOpen'
                ? 'data-bs-parent="#' + componentKey + '-accordionExample"'
                : '' 
           %>>
        <div class="accordion-body ari-mb-2">

          <% for (var j = 0; j < value[i].data.length; j++) { %>
            <div class="ari-flex ari-items-center ari-justify-between ari-flex-wrap ari-border-b ari-py-3 ari-gap-4">
              <span class="ari-font-bold"><%= utils.getLangText(value[i].data[j].label) %></span>
              <%= value[i].data[j].value || '-' %>
            </div>
          <% } %>

        </div>
      </div>
    </div>
  <% } %>
</div>
  `;
    }
    static get defaultFormattedTemplate() {
        return `
    [
  {
    "type": "datetime",
    "formatData": {
      "outputFormat": {
        "valueType": "VALUE",
        "value": "DD/MM/YYYY, HH:mm:ss"
      },
      "inputFormat": {
        "valueType": "VALUE",
        "value": "DD/MM/YYYY, HH:mm:ss"
      }
    }
  },
  {
    "type": "number",
    "formatData": {
      "format": {
        "valueType": "VALUE",
        "value": 2
      },
      "currency": {
        "valueType": "DATA",
        "value": "CcyId"
      }
    }
  },
  {
    "type": "amount",
    "formatData": {
      "format": {
        "valueType": "VALUE",
        "value": 2
      },
      "currency": {
        "valueType": "DATA",
        "value": "CcyId"
      }
    }
  }
]

    `;
    }
    render() {
        var view = `<div class="comfirm-wrapper" ref="${this.component.key}-comfirm"></div>`;
        return super.render(view);
    }
    setValue(value, flags = {}) {
        const changed = super.setValue(value, flags);
        if (changed) {
            this.textContent = value || '';
            this.redraw();
        }
        return changed;
    }
    getValue() {
        return this.value;
    }
    formatField(item) {
        var _a;
        // Format number
        if ((item.type === 'number' && item.value != null) || (item.type === 'amount' && item.value != null)) {
            return AriFormUtils.numberWithCommas(item.value);
        }
        // Format datetime
        if ((item.type === 'datetime') && item.value) {
            return (0, moment_1.default)(item.value).format('DD/MM/YYYY');
        }
        // Format default
        return (_a = item.value) !== null && _a !== void 0 ? _a : '-';
    }
    getDataSele() {
    }
    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        var _a;
        var refs = {};
        refs[`${this.component.key}-comfirm`] = 'single';
        this.loadRefs(element, refs);
        const form = this.getRoot();
        const formData = form ? form.data : {};
        const pages = form.pages || [];
        const keys = Object.keys((_a = this.component.listComponentKey) !== null && _a !== void 0 ? _a : {}).length > 0
            ? this.component.listComponentKey
            : [];
        const optionsFormart = this.component.formattedDataTemplate ? JSON.parse(this.component.formattedDataTemplate) : [];
        const dataRender = pages.map(page => {
            // Lọc key thuộc page này
            const fieldsInPage = keys
                .map(key => {
                var _a;
                const comp = page.getComponent(key);
                if (!comp)
                    return null; // field không thuộc page này → bỏ qua
                const formatItem = optionsFormart.find(opt => opt.type === comp.component.type) || {};
                var value = "";
                if (comp.component.type === 'select') {
                    const dataSelect = comp.selectOptions.find((v) => v.value == formData[key]);
                    if (dataSelect) {
                        value = `<span>${dataSelect.label}</span>`;
                    }
                    else if (formData[key] && Object.keys(formData[key]).length === 0) {
                        value = `<span>-</span>`;
                    }
                    else {
                        if (Array.isArray(formData[key])) {
                            const item = formData[key].map(v => {
                                const dataSelect = comp.selectOptions.find((option) => JSON.stringify(option.value) === JSON.stringify(v));
                                return dataSelect ? dataSelect.label : v;
                            }).join(', ');
                            value = `<span>${item}</span>`;
                        }
                        else if (typeof formData[key] === 'object') {
                            value = `<span>${((_a = comp.selectOptions.find((option) => JSON.stringify(option.value) === JSON.stringify(formData[key]))) === null || _a === void 0 ? void 0 : _a.label) || "-"}</span>`;
                        }
                        else if (typeof formData[key] === 'string' && formData[key].trim() !== '') {
                            value = `<span>${formData[key]}</span>`;
                        }
                        else {
                            value = `<span>-</span>`;
                        }
                    }
                }
                else if (comp.component.type === 'file') {
                    value = AriFormUtils.dynamicFormatTemplate(formData[key], comp.component.type, null, formData, comp.key);
                }
                else if (comp.component.type === 'textinfo') {
                    if (comp.component.showType === 'list') {
                        const dataTextInfo = formData[key] ? formData[key] : this.evaluate(comp.textContent, { form, comp }, 'value');
                        value = AriFormUtils.dynamicFormatTemplate(dataTextInfo, comp.component.type, formatItem.formatData, formData, comp.key, comp, form, AriFormUtils);
                    }
                    else {
                        value = AriFormUtils.dynamicFormat(formData[key], comp.component.type, null, formatItem.formatData, formData);
                    }
                }
                else
                    value = `<span>${AriFormUtils.dynamicFormat(formData[key], comp.component.type, formatItem.formatData, formData)}</span>`;
                return {
                    label: comp.component.label || key,
                    value,
                };
            })
                .filter(x => x !== null); // lọc field null
            return {
                title: page.component.title || page.component.label || "Untitled Page",
                data: fieldsInPage
            };
        }).filter((value) => value.data.length > 0);
        var templateStr = lodash_1.default.get(this.component, 'templatesComfirm');
        var renderByTemplate = lodash_1.default.template(templateStr);
        var html = renderByTemplate({
            value: dataRender,
            form,
            utils: AriFormUtils,
            data: form.getValue().data,
            componentKey: this.component.key,
            comfirmType: this.component.comfirmType || 'default'
        });
        this.refs[`${this.component.key}-comfirm`].innerHTML = html;
        return super.attach(element);
    }
    updateValue(value, flags) {
        const changed = super.updateValue(value, flags);
        this.previousValue = this.dataValue;
        return changed;
    }
}
ComfirmComponent.editForm = comfirm_form_1.default;
ComfirmComponent.builderInfo = {
    title: 'Comfirm',
    group: 'basic',
    icon: 'check-lg',
    weight: 3,
    documentation: 'http://help.ari.form/userguide/',
    schema: ComfirmComponent.schema()
};
exports.default = ComfirmComponent;
